module.exports = __webpack_public_path__ + "img/nierozliczono.02add53e.svg";